<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Job_Types')">
      <b-form-group
          :label="$t('message.Name_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="job_types.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="job_types.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="job_types.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="job_types.name_kz"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addJobTypes, editJobTypes, getJobTypeById} from "../../../../../../api/job_types";

export default {
  name: "jobModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      job_types: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchTypes(){
      getJobTypeById({ id: this.id}).then(response => {
        this.job_types = response.data.data
      })
    },
    handleSubmit() {
      if (this.job_types.name_uz
          && this.job_types.name_ru
          && this.job_types.name_en
          && this.job_types.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editJobTypes(this.job_types).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addJobTypes(this.job_types).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchTypes()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




